/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob0601Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob0601ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const whseJob0601FetchWhseJob0601Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob0601FetchWhseJob0601Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob0601AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const whseJob0601RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob0601SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob0601CreateWhseJob0601Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const whseJob0601CreateWhseJob0601Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob0601Types.WHSE_JOB0601_RESET_TIMESTAMP]: whseJob0601ResetTimestamp,
  [WhseJob0601Types.WHSE_JOB0601_FETCH_WHSE_JOB0601_LOADING]: whseJob0601FetchWhseJob0601Loading,
  [WhseJob0601Types.WHSE_JOB0601_FETCH_WHSE_JOB0601_SUCCESS]: whseJob0601FetchWhseJob0601Success,
  [WhseJob0601Types.WHSE_JOB0601_ADD_SELECTED_DOCUMENTS]: whseJob0601AddSelectedDocuments,
  [WhseJob0601Types.WHSE_JOB0601_REMOVE_SELECTED_DOCUMENTS]: whseJob0601RemoveSelectedDocuments,
  [WhseJob0601Types.WHSE_JOB0601_SET_WORKSPACE_VISIBLE]: whseJob0601SetWorkspaceVisible,
  [WhseJob0601Types.WHSE_JOB0601_CREATE_WHSE_JOB0601_LOADING]: whseJob0601CreateWhseJob0601Loading,
  [WhseJob0601Types.WHSE_JOB0601_CREATE_WHSE_JOB0601_SUCCESS]: whseJob0601CreateWhseJob0601Success
});
